const zIndexes = {
  BELOW_PACKAGE_Z_INDEX: 5,
  PACKAGE_Z_INDEX: 10,
  ABOVE_PACKAGE_Z_INDEX: 9999,
};

export default zIndexes;
